export default {
    pages: {
        key: "title",
        data: [
            // { title: 'Kezdőlap', url: '/', icon: 'HomeIcon', is_bookmarked: false },
            { title: 'Ügyletek', url: '/ugyletek', icon: 'FileIcon', is_bookmarked: false },
            { title: 'Dolgozók', url: '/dolgozok', icon: 'FileIcon', is_bookmarked: false },
            { title: 'Megrendelők', url: '/megrendelok', icon: 'FileIcon', is_bookmarked: false },
            { title: 'Ügylet tipusok', url: '/ugylet-tipusok', icon: 'FileIcon', is_bookmarked: false },
            { title: 'Ingatlan tipusok', url: '/ingatlan-tipusok', icon: 'FileIcon', is_bookmarked: false },
        ]
    }
}